import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import classes from './userblock.module.scss';

function UserBlock({
  userInfo: {
    userName, messageText, messageTime, notification, userImg,
  }, active, onClick, user, userMenu, setUserMenu,
}) {
  const chatDirectLoading = useSelector((state) => state.chat.chatDirectLoading);

  const onUserClick = (e) => {
    e.stopPropagation();
    setUserMenu({user});
  };

  return (
    <div
      style={{ cursor: active || chatDirectLoading ? 'default' : 'pointer' }}
      className={`${classes.wrapper} ${active ? classes.active : ''}`}
      onClick={() => !active && !chatDirectLoading && onClick()}
    >
      <figure className={classes.user_figure} onClick={(e) => onUserClick(e)}>
        <img className={classes.user_img} alt="avatar" src={userImg} />
      </figure>

      <div className={classes.message_info}>
        <h5 className={classes.user_name}>{userName}</h5>

        <div className={`${classes.message_text} ${notification && classes.notif}`}>{messageText}</div>

        {notification && <div className={classes.round_mini}>{notification}</div>}

        <p className={classes.message_time}>{messageTime}</p>
      </div>
    </div>
  );
}

UserBlock.propTypes = {
  userInfo: PropTypes.object.isRequired,
  user: PropTypes.object,
  onClick: PropTypes.func,
  active: PropTypes.bool,
};

UserBlock.defaultProps = {
  onClick: () => {},
  active: false,
  user: {},
};

export default UserBlock;
